<form class="container-input-autocomplete">
  <mat-label *ngIf="title" class="container-input-autocomplete__label">{{ title }}</mat-label>
  <mat-form-field>
    <input
      type="text"
      matInput
      [disabled]="disabled"
      [formControl]="value"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="onOptionSelected($event)" [autoActiveFirstOption]="false">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ getOptionText(option) }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
